angular.module('zc.commonApi')

.factory 'ProjectTitleSelector', ($resource, $q, BaseProjectCrudService) ->
  class ProjectTitleSelector extends BaseProjectCrudService

  new ProjectTitleSelector(
    $resource
    $q
    '/api/master/projects/:projectId/title_selectors/:id'
    'title_selector'
    'title_selectors'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/title_selector.service.coffee